import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-launch-progress',
  templateUrl: './launch-progress.component.html',
  imports: [NgClass, TranslatePipe],
})
export class LaunchProgressComponent {
  @Input() stages;
  launchStatus = {
    DONE: {
      class: 'green',
      icon: 'fa fa-square-check',
    },
    INPROGRESS: {
      class: '',
      icon: 'fa fa-regular fa-square gray',
    },
    TODO: {
      class: '',
      icon: 'fa fa-regular fa-square gray',
    },
    ERROR: {
      class: 'brown',
      icon: 'fa fa-exclamation-circle',
    },
  };
}
